import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
const MyContext = createContext();

let isLocal = false;
let backendUrl = !isLocal
  ? `${window.location.protocol}//${window.location.host}/api`
  : `http://127.0.0.1:5008`;
const queryParameters = new URLSearchParams(window.location.search)
const organizationCode = queryParameters.get("orgcode")
const subscriberCode = queryParameters.get("subcode")
const username = queryParameters.get("username")
const parentWebSite = queryParameters.get("website")

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MyContext.Provider
      value={{
        backendUrl,
        organizationCode,
        subscriberCode,
        username,
        parentWebSite
      }}
    >
      <App />
    </MyContext.Provider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export { MyContext };